
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {Box,Card,CardContent,Typography,FormControl,InputLabel,Select,MenuItem,Checkbox,FormControlLabel,Grid,
//   Button,Divider,Alert,Snackbar,TextField,IconButton,Dialog,DialogTitle,DialogContent,DialogActions,CircularProgress,
//   Breadcrumbs,Link,Chip,Tooltip,Avatar,Stack,
// } from "@mui/material";

// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddIcon from "@mui/icons-material/Add";
// import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
// import CloseIcon from "@mui/icons-material/Close";
// import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
// import MedicalServicesRoundedIcon from "@mui/icons-material/MedicalServicesRounded";
// import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
// import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
// import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
// import InboxRoundedIcon from "@mui/icons-material/InboxRounded";

// import axios from "axios";

// const API_URL = process.env.REACT_APP_API;

// // ─── Shared brand tokens ────────────────────────────────────────────────────
// const BRAND = {
//   primary: "#006D77",
//   primaryLight: "#00a8b5",
//   gradient: "linear-gradient(135deg, #006D77 0%, #00a8b5 100%)",
//   bg: "#F4F7F8",
//   border: "#E3EEEF",
//   danger: "#D32F2F",
// };

// // ─── Reusable: section card header ─────────────────────────────────────────
// const SectionHeader = ({ icon, title, subtitle, action }) => (
//   <Box sx={{display: "flex",justifyContent: "space-between",alignItems: "flex-start",mb: 2,gap: 2,flexWrap: "wrap",}}>
//     <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
//       <Avatar sx={{bgcolor: "rgba(0,109,119,0.08)",color: BRAND.primary,width: 40,height: 40,}} >
//         {icon}
//       </Avatar>
//       <Box>
//         <Typography variant="h6" fontWeight={700} sx={{ color: "#0F172A" }}>
//           {title}
//         </Typography>
//         {subtitle && (
//           <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
//             {subtitle}
//           </Typography>
//         )}
//       </Box>
//     </Box>
//     {action}
//   </Box>
// );

// // ─── Reusable: empty state ─────────────────────────────────────────────────
// const EmptyState = ({ text, action }) => (
//   <Box sx={{display: "flex",flexDirection: "column",alignItems: "center",justifyContent: "center",textAlign: "center",py: 5,px: 2,border: `1.5px dashed ${BRAND.border}`,borderRadius: 3,bgcolor: "#FAFCFC", }}>
//     <InboxRoundedIcon sx={{ fontSize: 36, color: "#94A3B8", mb: 1 }} />
//     <Typography variant="body2" color="text.secondary" sx={{ mb: action ? 2 : 0 }}>
//       {text}
//     </Typography>
//     {action}
//   </Box>
// );

// // ─── Reusable: confirmation dialog (replaces window.confirm) ──────────────
// const ConfirmDialog = ({ open, title, description, confirmLabel, onCancel, onConfirm, loading }) => (
//   <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
//     <DialogContent sx={{ pt: 4, pb: 2, px: 3 }}>
//       <Box
//         sx={{ width: 48, height: 48, borderRadius: "50%", bgcolor: "rgba(211,47,47,0.08)",
//           display: "flex",alignItems: "center",justifyContent: "center",mb: 2,
//          }}
//       >
//         <WarningAmberRoundedIcon sx={{ color: BRAND.danger }} />
//       </Box>
//       <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>
//         {title}
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {description}
//       </Typography>
//     </DialogContent>
//     <DialogActions sx={{ px: 3, pb: 3 }}>
//       <Button onClick={onCancel} sx={{ textTransform: "none", color: "#64748B" }}>
//         Cancel
//       </Button>
//       <Button
//         variant="contained"
//         color="error"
//         onClick={onConfirm}
//         disabled={loading}
//         sx={{ textTransform: "none", fontWeight: 600 }}
//       >
//         {loading ? "Please wait…" : confirmLabel}
//       </Button>
//     </DialogActions>
//   </Dialog>
// );

// export default function CommunityServices() {

//   const navigate = useNavigate();
//   const [communities, setCommunities] = useState([]);
//   const [services, setServices] = useState([]);

//   const [selectedCommunity, setSelectedCommunity] = useState("");
//   const [selectedServices, setSelectedServices] = useState([]);

//   const [loadingCommunities, setLoadingCommunities] = useState(false);
//   const [loadingServices, setLoadingServices] = useState(false);
//   const [loadingCommunityServices, setLoadingCommunityServices] = useState(false);
//   const [saving, setSaving] = useState(false);

//   // Add community dialog
//   const [communityDialogOpen, setCommunityDialogOpen] = useState(false);
//   const [communityName, setCommunityName] = useState("");
//   const [communitySaving, setCommunitySaving] = useState(false);

//   // Add services dialog (bulk)
//   const [serviceDialogOpen, setServiceDialogOpen] = useState(false);
//   const [bulkRows, setBulkRows] = useState([{ name: "", key: "" }]);
//   const [bulkSaving, setBulkSaving] = useState(false);

//   // Delete confirmations
//   const [deleteCommunityDialogOpen, setDeleteCommunityDialogOpen] = useState(false);
//   const [deletingCommunity, setDeletingCommunity] = useState(false);

//   const [deleteServiceTarget, setDeleteServiceTarget] = useState(null); // service object or null
//   const [deletingService, setDeletingService] = useState(false);

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const [communityAddress, setCommunityAddress] = useState({
//     address_1: "",
//     address_2: "",
//     city: "",
//     state: "",
//     pincode: "",
//   });

//   const [addressLoading, setAddressLoading] = useState(false);
//   const [addressSaving, setAddressSaving] = useState(false);


//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar((previous) => ({ ...previous, open: false }));
//   };


//   const fetchCommunities = async () => {
//     try {
//       setLoadingCommunities(true);
//       const response = await axios.get(`${API_URL}/community/config`);
//       setCommunities(response.data.communities || []);
//     } catch (error) {
//       console.error("Error fetching communities:", error);
//       showSnackbar("Couldn't load communities. Check your connection and try again.", "error");
//     } finally {
//       setLoadingCommunities(false);
//     }
//   };

//   const fetchServices = async () => {
//     try {
//       setLoadingServices(true);
//       const response = await axios.get(`${API_URL}/community/services`);
//       setServices(response.data.services || []);
//     } catch (error) {
//       console.error("Error fetching services:", error);
//       showSnackbar("Couldn't load services. Check your connection and try again.", "error");
//     } finally {
//       setLoadingServices(false);
//     }
//   };

//   useEffect(() => {
//     fetchCommunities();
//     fetchServices();
//   }, []);

//   const handleCommunityChange = async (event) => {
//     const communityId = event.target.value;
//     setSelectedCommunity(communityId);

//     if (!communityId) {
//       setSelectedServices([]);
//       setCommunityAddress({ address_1: "", address_2: "", city: "", state: "", pincode: "" });
//       return;
//     }

//     try {
//       setLoadingCommunityServices(true);
//       setAddressLoading(true);

//       const servicesResponse = await axios.get(
//         `${API_URL}/community/${communityId}/config-services`
//       );
//       setSelectedServices(servicesResponse.data.services || []);

//       const addressResponse = await axios.get(
//         `${API_URL}/community/${communityId}/address`
//       );

//       setCommunityAddress({
//         address_1: addressResponse.data.address?.address_1 || "",
//         address_2: addressResponse.data.address?.address_2 || "",
//         city: "Hyderabad",
//         state: "Telangana",
//         pincode: addressResponse.data.address?.pincode || "",
//       });

//     } catch (error) {
//       console.error("Error fetching community details:", error);

//       setSelectedServices([]);
//       setCommunityAddress({ address_1: "", address_2: "", city: "", state: "", pincode: "" });

//       // If address doesn't exist yet, that's expected for a new community — no error needed.
//       if (error.response?.status !== 404) {
//         showSnackbar("Couldn't load this community's details.", "error");
//       }

//     } finally {
//       setLoadingCommunityServices(false);
//       setAddressLoading(false);
//     }
//   };

//   const handleSaveAddress = async () => {
//     if (!selectedCommunity) {
//       showSnackbar("Select a community first.", "warning");
//       return;
//     }
//     if (!communityAddress.address_1.trim()) {
//       showSnackbar("Address 1 is required.", "warning");
//       return;
//     }
//     if (!communityAddress.pincode.trim()) {
//       showSnackbar("Pincode is required.", "warning");
//       return;
//     }

//     try {
//       setAddressSaving(true);

//       await axios.post(`${API_URL}/community/${selectedCommunity}/address`, {
//         address_1: communityAddress.address_1.trim(),
//         address_2: communityAddress.address_2.trim(),
//         pincode: communityAddress.pincode.trim(),
//         city: "Hyderabad",
//         state: "Telangana",
//       });

//       showSnackbar("Address saved.", "success");

//     } catch (error) {
//       console.error("Error saving community address:", error);
//       showSnackbar(
//         error.response?.data?.message || "Couldn't save the address. Try again.",
//         "error"
//       );
//     } finally {
//       setAddressSaving(false);
//     }
//   };


//   const handleServiceChange = (serviceKey) => {
//     setSelectedServices((previous) =>
//       previous.includes(serviceKey)
//         ? previous.filter((service) => service !== serviceKey)
//         : [...previous, serviceKey]
//     );
//   };

//   const handleSelectAll = () => {
//     if (selectedServices.length === services.length) {
//       setSelectedServices([]);
//     } else {
//       setSelectedServices(services.map((service) => service.key));
//     }
//   };

//   const handleSave = async () => {
//     if (!selectedCommunity) {
//       showSnackbar("Select a community first.", "warning");
//       return;
//     }

//     try {
//       setSaving(true);

//       await axios.post(`${API_URL}/community/${selectedCommunity}/services`, {
//         services: selectedServices,
//       });

//       showSnackbar("Configuration saved — changes are live for this community.", "success");

//     } catch (error) {
//       console.error("Error saving community services:", error);
//       showSnackbar(
//         error.response?.data?.message || "Couldn't save the configuration. Try again.",
//         "error"
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleAddCommunity = async () => {
//     const name = communityName.trim();

//     if (!name) {
//       showSnackbar("Enter a community name.", "warning");
//       return;
//     }

//     try {
//       setCommunitySaving(true);

//       const response = await axios.post(`${API_URL}/community`, { name });

//       showSnackbar(`"${name}" added.`, "success");

//       setCommunityDialogOpen(false);
//       setCommunityName("");

//       await fetchCommunities();

//       if (response.data.community) {
//         setSelectedCommunity(response.data.community.id);
//         setCommunityAddress({ address_1: "", address_2: "", city: "", state: "", pincode: "" });
//         setSelectedServices([]);
//       }

//     } catch (error) {
//       console.error("Error adding community:", error);
//       showSnackbar(
//         error.response?.data?.message || "Couldn't add the community. Try again.",
//         "error"
//       );
//     } finally {
//       setCommunitySaving(false);
//     }
//   };


//   const selectedCommunityObj = communities.find((c) => c.id === selectedCommunity);

//   const handleConfirmDeleteCommunity = async () => {
//     if (!selectedCommunity || !selectedCommunityObj) return;

//     try {
//       setDeletingCommunity(true);

//       await axios.delete(`${API_URL}/community/${selectedCommunity}`);

//       showSnackbar(`"${selectedCommunityObj.name}" deleted.`, "success");

//       setSelectedCommunity("");
//       setSelectedServices([]);
//       setDeleteCommunityDialogOpen(false);

//       await fetchCommunities();

//     } catch (error) {
//       console.error("Error deleting community:", error);
//       showSnackbar(
//         error.response?.data?.message || "Couldn't delete the community. Try again.",
//         "error"
//       );
//     } finally {
//       setDeletingCommunity(false);
//     }
//   };


//   const handleBulkRowChange = (index, field, value) => {
//     setBulkRows((previous) => {
//       const updated = [...previous];
//       updated[index] = { ...updated[index], [field]: value };
//       return updated;
//     });
//   };

//   const handleAddBulkRow = () => {
//     setBulkRows((previous) => [...previous, { name: "", key: "" }]);
//   };

//   const handleRemoveBulkRow = (index) => {
//     setBulkRows((previous) => previous.filter((_, i) => i !== index));
//   };

//   const resetBulkDialog = () => {
//     setServiceDialogOpen(false);
//     setBulkRows([{ name: "", key: "" }]);
//   };


//   const handleAddServicesBulk = async () => {

//     const validRows = bulkRows
//       .map((row) => ({ name: row.name.trim(), key: row.key.trim().toLowerCase() }))
//       .filter((row) => row.name);

//     if (validRows.length === 0) {
//       showSnackbar("Enter at least one service name.", "warning");
//       return;
//     }

//     const namesSeen = new Set();
//     const keysSeen = new Set();

//     for (const row of validRows) {
//       const effectiveKey =
//         row.key || row.name.toLowerCase().replace(/\s+/g, "_").replace(/[^a-z0-9_]/g, "");
//       const nameLower = row.name.toLowerCase();

//       if (namesSeen.has(nameLower) || keysSeen.has(effectiveKey)) {
//         showSnackbar(`"${row.name}" is entered more than once.`, "warning");
//         return;
//       }

//       namesSeen.add(nameLower);
//       keysSeen.add(effectiveKey);
//     }

//     try {
//       setBulkSaving(true);

//       const response = await axios.post(`${API_URL}/community/services/bulk`, {
//         services: validRows,
//       });

//       const addedCount = response.data.added?.length || 0;
//       const skipped = response.data.skipped || [];

//       if (addedCount > 0) {
//         const skippedNote = skipped.length
//           ? ` (${skipped.length} skipped — already existed)`
//           : "";
//         showSnackbar(
//           `${addedCount} service${addedCount === 1 ? "" : "s"} added${skippedNote}.`,
//           skipped.length > 0 ? "warning" : "success"
//         );
//       } else {
//         showSnackbar("Nothing added — those services already exist.", "warning");
//       }

//       resetBulkDialog();
//       await fetchServices();

//     } catch (error) {
//       console.error("Error adding services in bulk:", error);
//       showSnackbar(
//         error.response?.data?.message || "Couldn't add the services. Try again.",
//         "error"
//       );
//     } finally {
//       setBulkSaving(false);
//     }
//   };


//   const handleConfirmDeleteService = async () => {
//     if (!deleteServiceTarget) return;

//     try {
//       setDeletingService(true);

//       await axios.delete(`${API_URL}/community/services/${deleteServiceTarget.id}`);

//       showSnackbar(`"${deleteServiceTarget.name}" deleted.`, "success");

//       setSelectedServices((previous) =>
//         previous.filter((key) => key !== deleteServiceTarget.key)
//       );

//       setDeleteServiceTarget(null);
//       await fetchServices();

//     } catch (error) {
//       console.error("Error deleting service:", error);
//       showSnackbar(
//         error.response?.data?.message || "Couldn't delete the service. Try again.",
//         "error"
//       );
//     } finally {
//       setDeletingService(false);
//     }
//   };

//   const validBulkCount = bulkRows.filter((r) => r.name.trim()).length;

//   return (
//     <Box
//       sx={{
//         bgcolor: BRAND.bg,
//         minHeight: "100vh",
//         ml: { md: "300px" },
//         p: { xs: 2, sm: 3, md: 4 },
//       }}
//     >

//       <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
//         <Tooltip title="Go back">
//           <IconButton
//             onClick={() => navigate(-1)}
//             sx={{
//               bgcolor: "#fff",
//               border: `1px solid ${BRAND.border}`,
//               "&:hover": { bgcolor: "#F0F7F7", borderColor: BRAND.primaryLight },
//             }}
//           >
//             <ArrowBackIcon sx={{ color: BRAND.primary }} />
//           </IconButton>
//         </Tooltip>

//         <Breadcrumbs sx={{ fontSize: 14 }}>
//           <Link
//             component="button"
//             underline="hover"
//             color="text.secondary"
//             onClick={() => navigate(-1)}
//             sx={{ fontSize: 14 }}
//           >
//             Admin
//           </Link>
//           <Typography color="text.primary" sx={{ fontSize: 14, fontWeight: 600 }}>
//             Community &amp; Service Management
//           </Typography>
//         </Breadcrumbs>
//       </Box>

//       <Box
//         sx={{background: BRAND.gradient,color: "white",p: { xs: 2.5, md: 4 },borderRadius: 3,mb: 3,display: "flex",
//           justifyContent: "space-between",alignItems: "center",flexWrap: "wrap",gap: 2,boxShadow: "0 8px 24px rgba(0,109,119,0.25)",
//         }}
//       >
//         <Box>
//           <Typography variant="h4" fontWeight={800}>
//             Community Service Management
//           </Typography>
//           <Typography sx={{ opacity: 0.85, mt: 0.5, fontSize: 15 }}>
//             Manage communities, their addresses, and which services are available to each.
//           </Typography>
//         </Box>

//         <Stack direction="row" spacing={1.5} flexWrap="wrap">
//           <Chip
//             icon={<GroupsRoundedIcon sx={{ color: "#fff !important" }} />}
//             label={`${communities.length} ${communities.length === 1 ? "Community" : "Communities"}`}
//             sx={{
//               bgcolor: "rgba(255,255,255,0.16)",
//               color: "#fff",
//               fontWeight: 600,
//               px: 1,
//             }}
//           />
//           <Chip
//             icon={<MedicalServicesRoundedIcon sx={{ color: "#fff !important" }} />}
//             label={`${services.length} ${services.length === 1 ? "Service" : "Services"}`}
//             sx={{
//               bgcolor: "rgba(255,255,255,0.16)",
//               color: "#fff",
//               fontWeight: 600,
//               px: 1,
//             }}
//           />
//         </Stack>
//       </Box>


//       {/* ================================================= */}
//       {/* COMMUNITY MANAGEMENT */}
//       {/* ================================================= */}

//       <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
//         <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>

//           <SectionHeader
//             icon={<GroupsRoundedIcon />}
//             title="Communities"
//             subtitle="Add communities and pick one below to configure its address and services."
//             action={
//               <Button
//                 variant="contained"
//                 startIcon={<AddIcon />}
//                 onClick={() => setCommunityDialogOpen(true)}
//                 sx={{ background: BRAND.gradient, textTransform: "none", fontWeight: 600, borderRadius: 2, px: 2.5 }}
//               >
//                 Add Community
//               </Button>
//             }
//           />

//           <Divider sx={{ mb: 3 }} />

//           {!loadingCommunities && communities.length === 0 ? (
//             <EmptyState
//               text="No communities yet. Add your first one to start configuring services."
//               action={
//                 <Button
//                   variant="outlined"
//                   startIcon={<AddIcon />}
//                   onClick={() => setCommunityDialogOpen(true)}
//                   sx={{ textTransform: "none", color: BRAND.primary, borderColor: BRAND.primary }}
//                 >
//                   Add Community
//                 </Button>
//               }
//             />
//           ) : (
//             <>
//               <FormControl fullWidth sx={{ maxWidth: 600 }}>
//                 <InputLabel>Community</InputLabel>
//                 <Select
//                   value={selectedCommunity}
//                   label="Community"
//                   onChange={handleCommunityChange}
//                   disabled={loadingCommunities}
//                   sx={{ borderRadius: 2 }}
//                 >
//                   <MenuItem value="">
//                     <em>Select a community</em>
//                   </MenuItem>
//                   {communities.map((community) => (
//                     <MenuItem key={community.id} value={community.id}>
//                       {community.name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               {selectedCommunity && (
//                 <Button
//                   color="error"
//                   variant="text"
//                   startIcon={<DeleteIcon />}
//                   onClick={() => setDeleteCommunityDialogOpen(true)}
//                   sx={{ mt: 1.5, textTransform: "none", fontWeight: 600 }}
//                 >
//                   Delete this community
//                 </Button>
//               )}
//             </>
//           )}

//         </CardContent>
//       </Card>


//       {/* ================================================= */}
//       {/* COMMUNITY ADDRESS */}
//       {/* ================================================= */}

//       {selectedCommunity && (
//         <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
//           <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>

//             <SectionHeader
//               icon={<LocationOnRoundedIcon />}
//               title="Community Address"
//               subtitle={`Where ${selectedCommunityObj?.name || "this community"} is located.`}
//             />

//             <Divider sx={{ mb: 3 }} />

//             {addressLoading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
//                 <CircularProgress size={30} sx={{ color: BRAND.primary }} />
//               </Box>
//             ) : (
//               <>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="Address 1"
//                       value={communityAddress.address_1}
//                       onChange={(event) =>
//                         setCommunityAddress((previous) => ({ ...previous, address_1: event.target.value }))
//                       }
//                       placeholder="Building, street"
//                     />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="Address 2"
//                       value={communityAddress.address_2}
//                       onChange={(event) =>
//                         setCommunityAddress((previous) => ({ ...previous, address_2: event.target.value }))
//                       }
//                       placeholder="Landmark, area (optional)"
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Pincode"
//                       value={communityAddress.pincode}
//                       onChange={(event) =>
//                         setCommunityAddress((previous) => ({ ...previous, pincode: event.target.value }))
//                       }
//                       inputProps={{ maxLength: 6 }}
//                       placeholder="6-digit pincode"
//                     />
//                   </Grid>
//                 </Grid>

//                 <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
//                   <Button
//                     variant="contained"
//                     onClick={handleSaveAddress}
//                     disabled={addressSaving}
//                     sx={{
//                       background: BRAND.gradient,
//                       px: 4,
//                       py: 1.2,
//                       borderRadius: 2,
//                       textTransform: "none",
//                       fontWeight: 600,
//                     }}
//                   >
//                     {addressSaving ? "Saving…" : "Save Address"}
//                   </Button>
//                 </Box>
//               </>
//             )}
//           </CardContent>
//         </Card>
//       )}


//       {/* ================================================= */}
//       {/* COMMUNITY SERVICE CONFIGURATION */}
//       {/* ================================================= */}

//       {selectedCommunity && (
//         <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
//           <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>

//             <SectionHeader
//               icon={<TuneRoundedIcon />}
//               title="Configure Services"
//               subtitle={`Choose which services are available for ${selectedCommunityObj?.name || "this community"}.`}
//               action={
//                 services.length > 0 && (
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     onClick={handleSelectAll}
//                     sx={{ color: BRAND.primary, borderColor: BRAND.primary, textTransform: "none", fontWeight: 600 }}
//                   >
//                     {selectedServices.length === services.length && services.length > 0
//                       ? "Unselect All"
//                       : "Select All"}
//                   </Button>
//                 )
//               }
//             />

//             <Divider sx={{ mb: 3 }} />

//             {loadingCommunityServices ? (
//               <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//                 <CircularProgress sx={{ color: BRAND.primary }} />
//               </Box>
//             ) : services.length === 0 ? (
//               <EmptyState text="No services exist yet. Add services below before configuring this community." />
//             ) : (
//               <Grid container spacing={2}>
//                 {services.map((service) => {
//                   const isSelected = selectedServices.includes(service.key);

//                   return (
//                     <Grid item xs={12} sm={6} md={4} key={service.id}>
//                       <Card
//                         variant="outlined"
//                         onClick={() => handleServiceChange(service.key)}
//                         sx={{
//                           cursor: "pointer",
//                           borderRadius: 2,
//                           border: isSelected ? `2px solid ${BRAND.primaryLight}` : `1px solid ${BRAND.border}`,
//                           backgroundColor: isSelected ? "#F8FFFE" : "#ffffff",
//                           transition: "all 0.2s ease",
//                           "&:hover": {
//                             borderColor: BRAND.primaryLight,
//                             boxShadow: "0 4px 12px rgba(0,109,119,0.12)",
//                           },
//                         }}
//                       >
//                         <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 } }}>
//                           <FormControlLabel
//                             onClick={(event) => event.stopPropagation()}
//                             control={
//                               <Checkbox
//                                 checked={isSelected}
//                                 onChange={() => handleServiceChange(service.key)}
//                                 sx={{ color: BRAND.primary, "&.Mui-checked": { color: BRAND.primary } }}
//                               />
//                             }
//                             label={
//                               <Typography fontWeight={isSelected ? 600 : 500}>{service.name}</Typography>
//                             }
//                           />
//                         </CardContent>
//                       </Card>
//                     </Grid>
//                   );
//                 })}
//               </Grid>
//             )}

//             {services.length > 0 && (
//               <>
//                 <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
//                   {selectedServices.length} of {services.length} services selected
//                 </Typography>

//                 <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
//                   <Button
//                     variant="contained"
//                     onClick={handleSave}
//                     disabled={saving || loadingCommunityServices}
//                     sx={{
//                       background: BRAND.gradient,
//                       px: 4,
//                       py: 1.2,
//                       borderRadius: 2,
//                       textTransform: "none",
//                       fontWeight: 600,
//                     }}
//                   >
//                     {saving ? "Saving…" : "Save Configuration"}
//                   </Button>
//                 </Box>
//               </>
//             )}

//           </CardContent>
//         </Card>
//       )}


//       {/* ================================================= */}
//       {/* SERVICE MANAGEMENT */}
//       {/* ================================================= */}

//       <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
//         <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>

//           <SectionHeader
//             icon={<MedicalServicesRoundedIcon />}
//             title="Services"
//             subtitle="The master list of services offered across all communities."
//             action={
//               <Button
//                 variant="contained"
//                 startIcon={<AddIcon />}
//                 onClick={() => setServiceDialogOpen(true)}
//                 sx={{ background: BRAND.gradient, textTransform: "none", fontWeight: 600, borderRadius: 2, px: 2.5 }}
//               >
//                 Add Services
//               </Button>
//             }
//           />

//           <Divider sx={{ mb: 3 }} />

//           {loadingServices ? (
//             <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
//               <CircularProgress size={30} sx={{ color: BRAND.primary }} />
//             </Box>
//           ) : services.length === 0 ? (
//             <EmptyState
//               text={'No services added yet. Click "Add Services" to create your first one.'}
//               action={
//                 <Button
//                   variant="outlined"
//                   startIcon={<AddIcon />}
//                   onClick={() => setServiceDialogOpen(true)}
//                   sx={{ textTransform: "none", color: BRAND.primary, borderColor: BRAND.primary }}
//                 >
//                   Add Services
//                 </Button>
//               }
//             />
//           ) : (
//             <Grid container spacing={2}>
//               {services.map((service) => (
//                 <Grid item xs={12} sm={6} md={4} key={service.id}>
//                   <Card
//                     variant="outlined"
//                     sx={{
//                       borderRadius: 2,
//                       border: `1px solid ${BRAND.border}`,
//                       transition: "box-shadow 0.2s ease",
//                       "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.06)" },
//                     }}
//                   >
//                     <CardContent
//                       sx={{
//                         py: 1.5,
//                         "&:last-child": { pb: 1.5 },
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         gap: 1,
//                       }}
//                     >
//                       <Box sx={{ minWidth: 0 }}>
//                         <Typography fontWeight={600} noWrap>
//                           {service.name}
//                         </Typography>
//                         <Chip
//                           label={service.key}
//                           size="small"
//                           sx={{
//                             mt: 0.5,
//                             bgcolor: "rgba(0,109,119,0.08)",
//                             color: BRAND.primary,
//                             fontWeight: 600,
//                             fontSize: 11,
//                             height: 20,
//                           }}
//                         />
//                       </Box>

//                       <Tooltip title="Delete service">
//                         <IconButton
//                           color="error"
//                           onClick={() => setDeleteServiceTarget(service)}
//                         >
//                           <DeleteIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           )}

//         </CardContent>
//       </Card>


//       {/* ================================================= */}
//       {/* ADD COMMUNITY DIALOG */}
//       {/* ================================================= */}

//       <Dialog
//         open={communityDialogOpen}
//         onClose={() => { setCommunityDialogOpen(false); setCommunityName(""); }}
//         fullWidth
//         maxWidth="sm"
//       >
//         <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: 700 }}>
//           Add Community
//           <IconButton onClick={() => { setCommunityDialogOpen(false); setCommunityName(""); }} size="small">
//             <CloseIcon fontSize="small" />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent>
//           <TextField
//             autoFocus
//             fullWidth
//             label="Community Name"
//             placeholder="e.g. Lakeview Residency"
//             value={communityName}
//             onChange={(event) => setCommunityName(event.target.value)}
//             onKeyDown={(event) => event.key === "Enter" && handleAddCommunity()}
//             sx={{ mt: 1 }}
//           />
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 3 }}>
//           <Button
//             onClick={() => { setCommunityDialogOpen(false); setCommunityName(""); }}
//             sx={{ textTransform: "none", color: "#64748B" }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleAddCommunity}
//             disabled={communitySaving}
//             sx={{ background: BRAND.gradient, textTransform: "none", fontWeight: 600 }}
//           >
//             {communitySaving ? "Adding…" : "Add Community"}
//           </Button>
//         </DialogActions>
//       </Dialog>


//       {/* ================================================= */}
//       {/* ADD SERVICES DIALOG (BULK) */}
//       {/* ================================================= */}

//       <Dialog open={serviceDialogOpen} onClose={resetBulkDialog} fullWidth maxWidth="sm">
//         <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: 700 }}>
//           Add Services
//           <IconButton onClick={resetBulkDialog} size="small">
//             <CloseIcon fontSize="small" />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//             Add one service, or click "Add Another Service" to create several at once.
//             Leave the key blank to generate it automatically from the name.
//           </Typography>

//           {bulkRows.map((row, index) => (
//             <Box key={index} sx={{ display: "flex", gap: 1, alignItems: "flex-start", mb: 2 }}>
//               <TextField
//                 fullWidth
//                 autoFocus={index === 0}
//                 label="Service Name"
//                 placeholder="e.g. Physiotherapy"
//                 value={row.name}
//                 onChange={(event) => handleBulkRowChange(index, "name", event.target.value)}
//               />
//               <TextField
//                 fullWidth
//                 label="Service Key"
//                 placeholder="e.g. physiotherapy"
//                 value={row.key}
//                 onChange={(event) => handleBulkRowChange(index, "key", event.target.value)}
               
//               />
//               <Tooltip title="Remove row">
//                 <span>
//                   <IconButton
//                     color="error"
//                     disabled={bulkRows.length === 1}
//                     onClick={() => handleRemoveBulkRow(index)}
//                     sx={{ mt: 1 }}
//                   >
//                     <RemoveCircleOutlineIcon />
//                   </IconButton>
//                 </span>
//               </Tooltip>
//             </Box>
//           ))}

//           <Button
//             startIcon={<AddIcon />}
//             onClick={handleAddBulkRow}
//             sx={{ textTransform: "none", color: BRAND.primary, fontWeight: 600 }}
//           >
//             Add Another Service
//           </Button>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 3 }}>
//           <Button onClick={resetBulkDialog} sx={{ textTransform: "none", color: "#64748B" }}>
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleAddServicesBulk}
//             disabled={bulkSaving}
//             sx={{ background: BRAND.gradient, textTransform: "none", fontWeight: 600 }}
//           >
//             {bulkSaving
//               ? "Adding…"
//               : validBulkCount > 0
//               ? `Add ${validBulkCount} Service${validBulkCount === 1 ? "" : "s"}`
//               : "Add Services"}
//           </Button>
//         </DialogActions>
//       </Dialog>


//       {/* ================================================= */}
//       {/* CONFIRM DELETE — COMMUNITY */}
//       {/* ================================================= */}

//       <ConfirmDialog
//         open={deleteCommunityDialogOpen}
//         title="Delete this community?"
//         description={`This removes "${selectedCommunityObj?.name || ""}" and its service configuration. This can't be undone.`}
//         confirmLabel="Delete Community"
//         onCancel={() => setDeleteCommunityDialogOpen(false)}
//         onConfirm={handleConfirmDeleteCommunity}
//         loading={deletingCommunity}
//       />


//       {/* ================================================= */}
//       {/* CONFIRM DELETE — SERVICE */}
//       {/* ================================================= */}

//       <ConfirmDialog
//         open={Boolean(deleteServiceTarget)}
//         title="Delete this service?"
//         description={`This removes "${deleteServiceTarget?.name || ""}" from every community it's currently enabled for. This can't be undone.`}
//         confirmLabel="Delete Service"
//         onCancel={() => setDeleteServiceTarget(null)}
//         onConfirm={handleConfirmDeleteService}
//         loading={deletingService}
//       />


//       {/* ================================================= */}
//       {/* SNACKBAR */}
//       {/* ================================================= */}

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3500}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           variant="filled"
//           sx={{ width: "100%", borderRadius: 2 }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//     </Box>
//   );
// }






import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Card, CardContent, Typography, FormControl, InputLabel, Select, MenuItem,
  Checkbox, FormControlLabel, Grid, Button, Divider, Alert, Snackbar, TextField,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress,
  Breadcrumbs, Link, Chip, Tooltip, Avatar, Stack,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import MedicalServicesRoundedIcon from "@mui/icons-material/MedicalServicesRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import InboxRoundedIcon from "@mui/icons-material/InboxRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";

import axios from "axios";

const API_URL = process.env.REACT_APP_API;

// ─── Brand tokens (unchanged) ───────────────────────────────────────────────
const BRAND = {
  primary: "#006D77",
  primaryLight: "#00a8b5",
  gradient: "linear-gradient(135deg, #006D77 0%, #00a8b5 100%)",
  bg: "#F4F7F8",
  border: "#E3EEEF",
  danger: "#D32F2F",
};

// ─── Reusable: section card header ─────────────────────────────────────────
const SectionHeader = ({ icon, title, subtitle, action }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2, gap: 2, flexWrap: "wrap" }}>
    <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
      <Avatar sx={{ bgcolor: "rgba(0,109,119,0.08)", color: BRAND.primary, width: 40, height: 40 }}>
        {icon}
      </Avatar>
      <Box>
        <Typography variant="h6" fontWeight={700} sx={{ color: "#0F172A" }}>{title}</Typography>
        {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{subtitle}</Typography>}
      </Box>
    </Box>
    {action}
  </Box>
);

// ─── Reusable: empty state ──────────────────────────────────────────────────
const EmptyState = ({ text, action }) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", py: 5, px: 2, border: `1.5px dashed ${BRAND.border}`, borderRadius: 3, bgcolor: "#FAFCFC" }}>
    <InboxRoundedIcon sx={{ fontSize: 36, color: "#94A3B8", mb: 1 }} />
    <Typography variant="body2" color="text.secondary" sx={{ mb: action ? 2 : 0 }}>{text}</Typography>
    {action}
  </Box>
);

// ─── Reusable: confirm dialog ───────────────────────────────────────────────
const ConfirmDialog = ({ open, title, description, confirmLabel, onCancel, onConfirm, loading }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogContent sx={{ pt: 4, pb: 2, px: 3 }}>
      <Box sx={{ width: 48, height: 48, borderRadius: "50%", bgcolor: "rgba(211,47,47,0.08)", display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
        <WarningAmberRoundedIcon sx={{ color: BRAND.danger }} />
      </Box>
      <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>{title}</Typography>
      <Typography variant="body2" color="text.secondary">{description}</Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3 }}>
      <Button onClick={onCancel} sx={{ textTransform: "none", color: "#64748B" }}>Cancel</Button>
      <Button variant="contained" color="error" onClick={onConfirm} disabled={loading} sx={{ textTransform: "none", fontWeight: 600 }}>
        {loading ? "Please wait…" : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

// ─── Logo upload drop-zone (reused in dialog + existing community card) ─────
const LogoDropZone = ({ preview, onFile, onRemove, uploading, compact = false }) => {
  const [dragOver, setDragOver] = useState(false);
  const fileRef = useRef(null);

  const handleFile = (file) => {
    if (!file) return;
    const allowed = ["image/png", "image/jpeg", "image/jpg", "image/svg+xml", "image/webp"];
    if (!allowed.includes(file.type)) {
      alert("Only PNG, JPG, SVG or WEBP files are allowed.");
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      alert("Logo must be under 2 MB.");
      return;
    }
    onFile(file);
  };

  return (
    <Box>
      {/* Preview strip */}
      {preview && (
        <Box sx={{
          display: "flex", alignItems: "center", gap: 1.5, mb: 1.5,
          p: 1.5, borderRadius: 2, bgcolor: BRAND.primary, border: `1px solid ${BRAND.border}`,
        }}>
          <img
            src={preview}
            alt="Logo preview"
            style={{ height: compact ? 36 : 48, maxWidth: 140, objectFit: "contain" }}
          />
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", flex: 1 }}>
            Preview on dark background
          </Typography>
          <Tooltip title="Remove logo">
            <IconButton size="small" onClick={onRemove} sx={{ color: "rgba(255,255,255,0.7)", "&:hover": { color: "#fff" } }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      )}

      {/* Drop zone */}
      <Box
        onClick={() => fileRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={(e) => { e.preventDefault(); setDragOver(false); handleFile(e.dataTransfer.files[0]); }}
        sx={{
          border: `2px dashed ${dragOver ? BRAND.primary : BRAND.border}`,
          borderRadius: 2,
          p: compact ? 2 : 3,
          textAlign: "center",
          cursor: uploading ? "not-allowed" : "pointer",
          bgcolor: dragOver ? "rgba(0,109,119,0.04)" : "#FAFCFC",
          transition: "all 0.2s",
          "&:hover": { borderColor: BRAND.primary, bgcolor: "rgba(0,109,119,0.04)" },
        }}
      >
        <input
          ref={fileRef}
          type="file"
          accept="image/png,image/jpeg,image/jpg,image/svg+xml,image/webp"
          style={{ display: "none" }}
          onChange={(e) => handleFile(e.target.files[0])}
        />
        <CloudUploadRoundedIcon sx={{ fontSize: compact ? 24 : 32, color: "#94A3B8", mb: 0.5 }} />
        <Typography variant="body2" fontWeight={600} color="text.secondary">
          {uploading ? "Uploading…" : preview ? "Replace logo" : "Click or drag logo here"}
        </Typography>
        <Typography variant="caption" color="text.disabled">
          PNG, JPG, SVG, WEBP · max 2 MB
        </Typography>
      </Box>
    </Box>
  );
};


// ─── Logo management card for an already-saved community ───────────────────
const CommunityLogoCard = ({ community, onLogoSaved }) => {
  const [preview, setPreview] = useState(community.logo_url || "");
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [msg, setMsg] = useState(null); // { text, type }

  const handleFile = async (file) => {
    // Show local preview immediately
    const reader = new FileReader();
    reader.onload = (e) => setPreview(e.target.result);
    reader.readAsDataURL(file);

    setUploading(true);
    setMsg(null);

    try {
      const token = sessionStorage.getItem("token");
      const formData = new FormData();
      formData.append("logo", file);

      const res = await axios.post(
        `${API_URL}/community/${community.id}/logo`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );

      setPreview(res.data.logo_url);
      onLogoSaved?.(res.data.logo_url);
      setMsg({ text: "Logo saved.", type: "success" });
    } catch (err) {
      setMsg({ text: err.response?.data?.message || "Upload failed.", type: "error" });
      setPreview(community.logo_url || "");
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = async () => {
    if (!preview) return;
    setDeleting(true);
    setMsg(null);
    try {
      const token = sessionStorage.getItem("token");
      await axios.delete(`${API_URL}/community/${community.id}/logo`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPreview("");
      onLogoSaved?.("");
      setMsg({ text: "Logo removed.", type: "success" });
    } catch (err) {
      setMsg({ text: err.response?.data?.message || "Couldn't remove logo.", type: "error" });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Box>
      <LogoDropZone
        preview={preview}
        onFile={handleFile}
        onRemove={handleRemove}
        uploading={uploading || deleting}
        compact
      />
      {msg && (
        <Typography
          variant="caption"
          sx={{ display: "block", mt: 1, fontWeight: 600, color: msg.type === "success" ? "#059669" : BRAND.danger }}
        >
          {msg.type === "success" ? "✓" : "⚠"} {msg.text}
        </Typography>
      )}
    </Box>
  );
};


// ════════════════════════════════════════════════════════════════════════════
// Main component
// ════════════════════════════════════════════════════════════════════════════
export default function CommunityServices() {
  const navigate = useNavigate();

  const [communities, setCommunities] = useState([]);
  const [services, setServices] = useState([]);

  const [selectedCommunity, setSelectedCommunity] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);

  const [loadingCommunities, setLoadingCommunities] = useState(false);
  const [loadingServices, setLoadingServices] = useState(false);
  const [loadingCommunityServices, setLoadingCommunityServices] = useState(false);
  const [saving, setSaving] = useState(false);

  // Add community dialog
  const [communityDialogOpen, setCommunityDialogOpen] = useState(false);
  const [communityName, setCommunityName] = useState("");
  const [communitySaving, setCommunitySaving] = useState(false);
  // Logo state for the "Add Community" dialog
  const [newLogoFile, setNewLogoFile] = useState(null);       // raw File
  const [newLogoPreview, setNewLogoPreview] = useState("");   // data URL for preview
  const [logoUploading, setLogoUploading] = useState(false);

  // Add services dialog (bulk)
  const [serviceDialogOpen, setServiceDialogOpen] = useState(false);
  const [bulkRows, setBulkRows] = useState([{ name: "", key: "" }]);
  const [bulkSaving, setBulkSaving] = useState(false);

  // Delete confirmations
  const [deleteCommunityDialogOpen, setDeleteCommunityDialogOpen] = useState(false);
  const [deletingCommunity, setDeletingCommunity] = useState(false);
  const [deleteServiceTarget, setDeleteServiceTarget] = useState(null);
  const [deletingService, setDeletingService] = useState(false);

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const [communityAddress, setCommunityAddress] = useState({
    address_1: "", address_2: "", city: "", state: "", pincode: "",
  });
  const [addressLoading, setAddressLoading] = useState(false);
  const [addressSaving, setAddressSaving] = useState(false);

  const showSnackbar = (message, severity = "success") =>
    setSnackbar({ open: true, message, severity });

  const handleCloseSnackbar = () =>
    setSnackbar((p) => ({ ...p, open: false }));

  // ── fetch helpers ──────────────────────────────────────────────────────
  const fetchCommunities = async () => {
    try {
      setLoadingCommunities(true);
      const res = await axios.get(`${API_URL}/community/config`);
      setCommunities(res.data.communities || []);
    } catch {
      showSnackbar("Couldn't load communities.", "error");
    } finally {
      setLoadingCommunities(false);
    }
  };

  const fetchServices = async () => {
    try {
      setLoadingServices(true);
      const res = await axios.get(`${API_URL}/community/services`);
      setServices(res.data.services || []);
    } catch {
      showSnackbar("Couldn't load services.", "error");
    } finally {
      setLoadingServices(false);
    }
  };

  useEffect(() => {
    fetchCommunities();
    fetchServices();
  }, []);

  // ── community select ───────────────────────────────────────────────────
  const handleCommunityChange = async (event) => {
    const communityId = event.target.value;
    setSelectedCommunity(communityId);

    if (!communityId) {
      setSelectedServices([]);
      setCommunityAddress({ address_1: "", address_2: "", city: "", state: "", pincode: "" });
      return;
    }

    try {
      setLoadingCommunityServices(true);
      setAddressLoading(true);

      const [servicesRes, addressRes] = await Promise.all([
        axios.get(`${API_URL}/community/${communityId}/config-services`),
        axios.get(`${API_URL}/community/${communityId}/address`),
      ]);

      setSelectedServices(servicesRes.data.services || []);
      setCommunityAddress({
        address_1: addressRes.data.address?.address_1 || "",
        address_2: addressRes.data.address?.address_2 || "",
        city: "Hyderabad",
        state: "Telangana",
        pincode: addressRes.data.address?.pincode || "",
      });
    } catch (err) {
      setSelectedServices([]);
      setCommunityAddress({ address_1: "", address_2: "", city: "", state: "", pincode: "" });
      if (err.response?.status !== 404) showSnackbar("Couldn't load community details.", "error");
    } finally {
      setLoadingCommunityServices(false);
      setAddressLoading(false);
    }
  };

  // ── address save ───────────────────────────────────────────────────────
  const handleSaveAddress = async () => {
    if (!selectedCommunity) { showSnackbar("Select a community first.", "warning"); return; }
    if (!communityAddress.address_1.trim()) { showSnackbar("Address 1 is required.", "warning"); return; }
    if (!communityAddress.pincode.trim()) { showSnackbar("Pincode is required.", "warning"); return; }

    try {
      setAddressSaving(true);
      await axios.post(`${API_URL}/community/${selectedCommunity}/address`, {
        address_1: communityAddress.address_1.trim(),
        address_2: communityAddress.address_2.trim(),
        pincode: communityAddress.pincode.trim(),
        city: "Hyderabad",
        state: "Telangana",
      });
      showSnackbar("Address saved.", "success");
    } catch (err) {
      showSnackbar(err.response?.data?.message || "Couldn't save the address.", "error");
    } finally {
      setAddressSaving(false);
    }
  };

  // ── service toggle ─────────────────────────────────────────────────────
  const handleServiceChange = (key) =>
    setSelectedServices((p) => p.includes(key) ? p.filter((k) => k !== key) : [...p, key]);

  const handleSelectAll = () =>
    setSelectedServices(selectedServices.length === services.length ? [] : services.map((s) => s.key));

  // ── save service config ────────────────────────────────────────────────
  const handleSave = async () => {
    if (!selectedCommunity) { showSnackbar("Select a community first.", "warning"); return; }
    try {
      setSaving(true);
      await axios.post(`${API_URL}/community/${selectedCommunity}/services`, { services: selectedServices });
      showSnackbar("Configuration saved — changes are live for this community.", "success");
    } catch (err) {
      showSnackbar(err.response?.data?.message || "Couldn't save the configuration.", "error");
    } finally {
      setSaving(false);
    }
  };

  // ── logo file pick (inside "Add Community" dialog) ─────────────────────
  const handleNewLogoFile = (file) => {
    setNewLogoFile(file);
    const reader = new FileReader();
    reader.onload = (e) => setNewLogoPreview(e.target.result);
    reader.readAsDataURL(file);
  };

  const handleClearNewLogo = () => {
    setNewLogoFile(null);
    setNewLogoPreview("");
  };

  // ── upload logo for a given community id ──────────────────────────────
  const uploadLogoForCommunity = async (communityId, file) => {
    if (!file) return null;
    const token = sessionStorage.getItem("token");
    const formData = new FormData();
    formData.append("logo", file);
    const res = await axios.post(
      `${API_URL}/community/${communityId}/logo`,
      formData,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    );
    return res.data.logo_url || null;
  };

  // ── add community (with optional logo) ────────────────────────────────
  const handleAddCommunity = async () => {
    const name = communityName.trim();
    if (!name) { showSnackbar("Enter a community name.", "warning"); return; }

    try {
      setCommunitySaving(true);

      // 1. Create community
      const res = await axios.post(`${API_URL}/community`, { name });
      const newCommunity = res.data.community;

      // 2. Upload logo if one was chosen
      if (newLogoFile && newCommunity?.id) {
        try {
          setLogoUploading(true);
          const logoUrl = await uploadLogoForCommunity(newCommunity.id, newLogoFile);
          // Patch the local community list with the logo so the logo card shows it immediately
          if (logoUrl) {
            newCommunity.logo_url = logoUrl;
          }
        } catch (logoErr) {
          // Non-fatal — community was created, logo just didn't upload
          showSnackbar(`"${name}" added, but logo upload failed. You can re-upload below.`, "warning");
        } finally {
          setLogoUploading(false);
        }
      }

      showSnackbar(`"${name}" added.`, "success");
      setCommunityDialogOpen(false);
      setCommunityName("");
      setNewLogoFile(null);
      setNewLogoPreview("");

      await fetchCommunities();

      if (newCommunity) {
        setSelectedCommunity(newCommunity.id);
        setCommunityAddress({ address_1: "", address_2: "", city: "", state: "", pincode: "" });
        setSelectedServices([]);
      }
    } catch (err) {
      showSnackbar(err.response?.data?.message || "Couldn't add the community.", "error");
    } finally {
      setCommunitySaving(false);
    }
  };

  const handleCloseCommunityDialog = () => {
    if (communitySaving) return;
    setCommunityDialogOpen(false);
    setCommunityName("");
    setNewLogoFile(null);
    setNewLogoPreview("");
  };

  // ── delete community ───────────────────────────────────────────────────
  const selectedCommunityObj = communities.find((c) => c.id === selectedCommunity);

  const handleConfirmDeleteCommunity = async () => {
    if (!selectedCommunity || !selectedCommunityObj) return;
    try {
      setDeletingCommunity(true);
      await axios.delete(`${API_URL}/community/${selectedCommunity}`);
      showSnackbar(`"${selectedCommunityObj.name}" deleted.`, "success");
      setSelectedCommunity("");
      setSelectedServices([]);
      setDeleteCommunityDialogOpen(false);
      await fetchCommunities();
    } catch (err) {
      showSnackbar(err.response?.data?.message || "Couldn't delete the community.", "error");
    } finally {
      setDeletingCommunity(false);
    }
  };

  // ── bulk services ──────────────────────────────────────────────────────
  const handleBulkRowChange = (index, field, value) =>
    setBulkRows((p) => { const u = [...p]; u[index] = { ...u[index], [field]: value }; return u; });

  const handleAddBulkRow = () => setBulkRows((p) => [...p, { name: "", key: "" }]);
  const handleRemoveBulkRow = (index) => setBulkRows((p) => p.filter((_, i) => i !== index));
  const resetBulkDialog = () => { setServiceDialogOpen(false); setBulkRows([{ name: "", key: "" }]); };

  const handleAddServicesBulk = async () => {
    const validRows = bulkRows
      .map((r) => ({ name: r.name.trim(), key: r.key.trim().toLowerCase() }))
      .filter((r) => r.name);

    if (validRows.length === 0) { showSnackbar("Enter at least one service name.", "warning"); return; }

    const namesSeen = new Set(), keysSeen = new Set();
    for (const r of validRows) {
      const k = r.key || r.name.toLowerCase().replace(/\s+/g, "_").replace(/[^a-z0-9_]/g, "");
      if (namesSeen.has(r.name.toLowerCase()) || keysSeen.has(k)) {
        showSnackbar(`"${r.name}" is entered more than once.`, "warning"); return;
      }
      namesSeen.add(r.name.toLowerCase()); keysSeen.add(k);
    }

    try {
      setBulkSaving(true);
      const res = await axios.post(`${API_URL}/community/services/bulk`, { services: validRows });
      const addedCount = res.data.added?.length || 0;
      const skipped = res.data.skipped || [];
      if (addedCount > 0) {
        showSnackbar(
          `${addedCount} service${addedCount === 1 ? "" : "s"} added${skipped.length ? ` (${skipped.length} skipped — already existed)` : ""}.`,
          skipped.length > 0 ? "warning" : "success"
        );
      } else {
        showSnackbar("Nothing added — those services already exist.", "warning");
      }
      resetBulkDialog();
      await fetchServices();
    } catch (err) {
      showSnackbar(err.response?.data?.message || "Couldn't add the services.", "error");
    } finally {
      setBulkSaving(false);
    }
  };

  // ── delete service ─────────────────────────────────────────────────────
  const handleConfirmDeleteService = async () => {
    if (!deleteServiceTarget) return;
    try {
      setDeletingService(true);
      await axios.delete(`${API_URL}/community/services/${deleteServiceTarget.id}`);
      showSnackbar(`"${deleteServiceTarget.name}" deleted.`, "success");
      setSelectedServices((p) => p.filter((k) => k !== deleteServiceTarget.key));
      setDeleteServiceTarget(null);
      await fetchServices();
    } catch (err) {
      showSnackbar(err.response?.data?.message || "Couldn't delete the service.", "error");
    } finally {
      setDeletingService(false);
    }
  };

  const validBulkCount = bulkRows.filter((r) => r.name.trim()).length;

  // ── helper: update a community's logo_url in local state ──────────────
  const patchCommunityLogo = (communityId, logoUrl) => {
    setCommunities((prev) =>
      prev.map((c) => c.id === communityId ? { ...c, logo_url: logoUrl } : c)
    );
  };

  // ═══════════════════════════════════════════════════════════════════════
  // Render
  // ═══════════════════════════════════════════════════════════════════════
  return (
    <Box sx={{ bgcolor: BRAND.bg, minHeight: "100vh", ml: { md: "300px" }, p: { xs: 2, sm: 3, md: 4 } }}>

      {/* ── Breadcrumb ── */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <Tooltip title="Go back">
          <IconButton onClick={() => navigate(-1)} sx={{ bgcolor: "#fff", border: `1px solid ${BRAND.border}`, "&:hover": { bgcolor: "#F0F7F7", borderColor: BRAND.primaryLight } }}>
            <ArrowBackIcon sx={{ color: BRAND.primary }} />
          </IconButton>
        </Tooltip>
        <Breadcrumbs sx={{ fontSize: 14 }}>
          <Link component="button" underline="hover" color="text.secondary" onClick={() => navigate(-1)} sx={{ fontSize: 14 }}>Admin</Link>
          <Typography color="text.primary" sx={{ fontSize: 14, fontWeight: 600 }}>Community &amp; Service Management</Typography>
        </Breadcrumbs>
      </Box>

      {/* ── Hero header ── */}
      <Box sx={{ background: BRAND.gradient, color: "white", p: { xs: 2.5, md: 4 }, borderRadius: 3, mb: 3, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2, boxShadow: "0 8px 24px rgba(0,109,119,0.25)" }}>
        <Box>
          <Typography variant="h4" fontWeight={800}>Community Service Management</Typography>
          <Typography sx={{ opacity: 0.85, mt: 0.5, fontSize: 15 }}>
            Manage communities, their logos, addresses, and service availability.
          </Typography>
        </Box>
        <Stack direction="row" spacing={1.5} flexWrap="wrap">
          <Chip icon={<GroupsRoundedIcon sx={{ color: "#fff !important" }} />} label={`${communities.length} ${communities.length === 1 ? "Community" : "Communities"}`} sx={{ bgcolor: "rgba(255,255,255,0.16)", color: "#fff", fontWeight: 600, px: 1 }} />
          <Chip icon={<MedicalServicesRoundedIcon sx={{ color: "#fff !important" }} />} label={`${services.length} ${services.length === 1 ? "Service" : "Services"}`} sx={{ bgcolor: "rgba(255,255,255,0.16)", color: "#fff", fontWeight: 600, px: 1 }} />
        </Stack>
      </Box>

      {/* ═══════════════════════════════════════════════════════ */}
      {/* COMMUNITY MANAGEMENT                                    */}
      {/* ═══════════════════════════════════════════════════════ */}
      <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
        <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <SectionHeader
            icon={<GroupsRoundedIcon />}
            title="Communities"
            subtitle="Add communities and select one to configure its logo, address and services."
            action={
              <Button variant="contained" startIcon={<AddIcon />} onClick={() => setCommunityDialogOpen(true)} sx={{ background: BRAND.gradient, textTransform: "none", fontWeight: 600, borderRadius: 2, px: 2.5 }}>
                Add Community
              </Button>
            }
          />
          <Divider sx={{ mb: 3 }} />

          {!loadingCommunities && communities.length === 0 ? (
            <EmptyState
              text="No communities yet. Add your first one to start configuring services."
              action={
                <Button variant="outlined" startIcon={<AddIcon />} onClick={() => setCommunityDialogOpen(true)} sx={{ textTransform: "none", color: BRAND.primary, borderColor: BRAND.primary }}>
                  Add Community
                </Button>
              }
            />
          ) : (
            <>
              <FormControl fullWidth sx={{ maxWidth: 600 }}>
                <InputLabel>Community</InputLabel>
                <Select value={selectedCommunity} label="Community" onChange={handleCommunityChange} disabled={loadingCommunities} sx={{ borderRadius: 2 }}>
                  <MenuItem value=""><em>Select a community</em></MenuItem>
                  {communities.map((c) => (
                    <MenuItem key={c.id} value={c.id}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        {c.logo_url ? (
                          <Box sx={{ width: 28, height: 28, borderRadius: 1, bgcolor: BRAND.primary, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 }}>
                            <img src={c.logo_url} alt="" style={{ maxWidth: 24, maxHeight: 24, objectFit: "contain" }} />
                          </Box>
                        ) : (
                          <Box sx={{ width: 28, height: 28, borderRadius: 1, bgcolor: "rgba(0,109,119,0.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <ImageRoundedIcon sx={{ fontSize: 16, color: "#94A3B8" }} />
                          </Box>
                        )}
                        {c.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {selectedCommunity && (
                <Button color="error" variant="text" startIcon={<DeleteIcon />} onClick={() => setDeleteCommunityDialogOpen(true)} sx={{ mt: 1.5, textTransform: "none", fontWeight: 600 }}>
                  Delete this community
                </Button>
              )}
            </>
          )}
        </CardContent>
      </Card>

      {/* ═══════════════════════════════════════════════════════ */}
      {/* COMMUNITY LOGO (for existing community)                 */}
      {/* ═══════════════════════════════════════════════════════ */}
      {selectedCommunity && (
        <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
          <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
            <SectionHeader
              icon={<ImageRoundedIcon />}
              title="Community Logo"
              subtitle={`Shown to residents of ${selectedCommunityObj?.name || "this community"} on the home screen. Use a transparent PNG or SVG.`}
            />
            <Divider sx={{ mb: 3 }} />

            <Box sx={{ maxWidth: 480 }}>
              <CommunityLogoCard
                key={selectedCommunity}                    // remount when community changes
                community={selectedCommunityObj || { id: selectedCommunity, logo_url: "" }}
                onLogoSaved={(url) => patchCommunityLogo(selectedCommunity, url)}
              />
            </Box>
          </CardContent>
        </Card>
      )}

      {/* ═══════════════════════════════════════════════════════ */}
      {/* COMMUNITY ADDRESS                                       */}
      {/* ═══════════════════════════════════════════════════════ */}
      {selectedCommunity && (
        <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
          <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
            <SectionHeader
              icon={<LocationOnRoundedIcon />}
              title="Community Address"
              subtitle={`Where ${selectedCommunityObj?.name || "this community"} is located.`}
            />
            <Divider sx={{ mb: 3 }} />

            {addressLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                <CircularProgress size={30} sx={{ color: BRAND.primary }} />
              </Box>
            ) : (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField fullWidth label="Address 1" value={communityAddress.address_1}
                      onChange={(e) => setCommunityAddress((p) => ({ ...p, address_1: e.target.value }))}
                      placeholder="Building, street" />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth label="Address 2" value={communityAddress.address_2}
                      onChange={(e) => setCommunityAddress((p) => ({ ...p, address_2: e.target.value }))}
                      placeholder="Landmark, area (optional)" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Pincode" value={communityAddress.pincode}
                      onChange={(e) => setCommunityAddress((p) => ({ ...p, pincode: e.target.value }))}
                      inputProps={{ maxLength: 6 }} placeholder="6-digit pincode" />
                  </Grid>
                </Grid>
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                  <Button variant="contained" onClick={handleSaveAddress} disabled={addressSaving}
                    sx={{ background: BRAND.gradient, px: 4, py: 1.2, borderRadius: 2, textTransform: "none", fontWeight: 600 }}>
                    {addressSaving ? "Saving…" : "Save Address"}
                  </Button>
                </Box>
              </>
            )}
          </CardContent>
        </Card>
      )}

      {/* ═══════════════════════════════════════════════════════ */}
      {/* COMMUNITY SERVICE CONFIGURATION                         */}
      {/* ═══════════════════════════════════════════════════════ */}
      {selectedCommunity && (
        <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
          <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
            <SectionHeader
              icon={<TuneRoundedIcon />}
              title="Configure Services"
              subtitle={`Choose which services are available for ${selectedCommunityObj?.name || "this community"}.`}
              action={
                services.length > 0 && (
                  <Button variant="outlined" size="small" onClick={handleSelectAll}
                    sx={{ color: BRAND.primary, borderColor: BRAND.primary, textTransform: "none", fontWeight: 600 }}>
                    {selectedServices.length === services.length && services.length > 0 ? "Unselect All" : "Select All"}
                  </Button>
                )
              }
            />
            <Divider sx={{ mb: 3 }} />

            {loadingCommunityServices ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                <CircularProgress sx={{ color: BRAND.primary }} />
              </Box>
            ) : services.length === 0 ? (
              <EmptyState text="No services exist yet. Add services below before configuring this community." />
            ) : (
              <Grid container spacing={2}>
                {services.map((service) => {
                  const isSelected = selectedServices.includes(service.key);
                  return (
                    <Grid item xs={12} sm={6} md={4} key={service.id}>
                      <Card variant="outlined" onClick={() => handleServiceChange(service.key)} sx={{
                        cursor: "pointer", borderRadius: 2,
                        border: isSelected ? `2px solid ${BRAND.primaryLight}` : `1px solid ${BRAND.border}`,
                        backgroundColor: isSelected ? "#F8FFFE" : "#ffffff",
                        transition: "all 0.2s ease",
                        "&:hover": { borderColor: BRAND.primaryLight, boxShadow: "0 4px 12px rgba(0,109,119,0.12)" },
                      }}>
                        <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 } }}>
                          <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={<Checkbox checked={isSelected} onChange={() => handleServiceChange(service.key)} sx={{ color: BRAND.primary, "&.Mui-checked": { color: BRAND.primary } }} />}
                            label={<Typography fontWeight={isSelected ? 600 : 500}>{service.name}</Typography>}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            )}

            {services.length > 0 && (
              <>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
                  {selectedServices.length} of {services.length} services selected
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                  <Button variant="contained" onClick={handleSave} disabled={saving || loadingCommunityServices}
                    sx={{ background: BRAND.gradient, px: 4, py: 1.2, borderRadius: 2, textTransform: "none", fontWeight: 600 }}>
                    {saving ? "Saving…" : "Save Configuration"}
                  </Button>
                </Box>
              </>
            )}
          </CardContent>
        </Card>
      )}

      {/* ═══════════════════════════════════════════════════════ */}
      {/* SERVICE MANAGEMENT                                      */}
      {/* ═══════════════════════════════════════════════════════ */}
      <Card sx={{ borderRadius: 3, mb: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: `1px solid ${BRAND.border}` }}>
        <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <SectionHeader
            icon={<MedicalServicesRoundedIcon />}
            title="Services"
            subtitle="The master list of services offered across all communities."
            action={
              <Button variant="contained" startIcon={<AddIcon />} onClick={() => setServiceDialogOpen(true)} sx={{ background: BRAND.gradient, textTransform: "none", fontWeight: 600, borderRadius: 2, px: 2.5 }}>
                Add Services
              </Button>
            }
          />
          <Divider sx={{ mb: 3 }} />

          {loadingServices ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
              <CircularProgress size={30} sx={{ color: BRAND.primary }} />
            </Box>
          ) : services.length === 0 ? (
            <EmptyState
              text={'No services added yet. Click "Add Services" to create your first one.'}
              action={
                <Button variant="outlined" startIcon={<AddIcon />} onClick={() => setServiceDialogOpen(true)} sx={{ textTransform: "none", color: BRAND.primary, borderColor: BRAND.primary }}>
                  Add Services
                </Button>
              }
            />
          ) : (
            <Grid container spacing={2}>
              {services.map((service) => (
                <Grid item xs={12} sm={6} md={4} key={service.id}>
                  <Card variant="outlined" sx={{ borderRadius: 2, border: `1px solid ${BRAND.border}`, transition: "box-shadow 0.2s ease", "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.06)" } }}>
                    <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 }, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography fontWeight={600} noWrap>{service.name}</Typography>
                        <Chip label={service.key} size="small" sx={{ mt: 0.5, bgcolor: "rgba(0,109,119,0.08)", color: BRAND.primary, fontWeight: 600, fontSize: 11, height: 20 }} />
                      </Box>
                      <Tooltip title="Delete service">
                        <IconButton color="error" onClick={() => setDeleteServiceTarget(service)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </CardContent>
      </Card>

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* ADD COMMUNITY DIALOG — now includes logo upload                    */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      <Dialog open={communityDialogOpen} onClose={handleCloseCommunityDialog} fullWidth maxWidth="sm">
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: 700 }}>
          Add Community
          <IconButton onClick={handleCloseCommunityDialog} size="small" disabled={communitySaving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pb: 1 }}>
          {/* Community name */}
          <TextField
            autoFocus
            fullWidth
            label="Community Name"
            placeholder="e.g. Muppa Residency"
            value={communityName}
            onChange={(e) => setCommunityName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !newLogoFile && handleAddCommunity()}
            sx={{ mt: 1, mb: 3 }}
          />

          {/* Logo upload */}
          <Box sx={{ mb: 1 }}>
            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5, color: "#0F172A" }}>
              Community Logo <Typography component="span" variant="caption" color="text.secondary">(optional — you can add it later too)</Typography>
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
              Shown on the resident home screen. Transparent PNG or SVG recommended, min 200 × 80 px.
            </Typography>

            <LogoDropZone
              preview={newLogoPreview}
              onFile={handleNewLogoFile}
              onRemove={handleClearNewLogo}
              uploading={logoUploading}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={handleCloseCommunityDialog} disabled={communitySaving} sx={{ textTransform: "none", color: "#64748B" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddCommunity}
            disabled={communitySaving}
            sx={{ background: BRAND.gradient, textTransform: "none", fontWeight: 600 }}
          >
            {communitySaving
              ? logoUploading ? "Uploading logo…" : "Adding…"
              : newLogoFile ? "Add Community & Upload Logo" : "Add Community"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════ */}
      {/* ADD SERVICES DIALOG (BULK)                              */}
      {/* ═══════════════════════════════════════════════════════ */}
      <Dialog open={serviceDialogOpen} onClose={resetBulkDialog} fullWidth maxWidth="sm">
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: 700 }}>
          Add Services
          <IconButton onClick={resetBulkDialog} size="small"><CloseIcon fontSize="small" /></IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Add one service, or click "Add Another Service" to create several at once.
            Leave the key blank to generate it automatically from the name.
          </Typography>
          {bulkRows.map((row, index) => (
            <Box key={index} sx={{ display: "flex", gap: 1, alignItems: "flex-start", mb: 2 }}>
              <TextField fullWidth autoFocus={index === 0} label="Service Name" placeholder="e.g. Physiotherapy" value={row.name} onChange={(e) => handleBulkRowChange(index, "name", e.target.value)} />
              <TextField fullWidth label="Service Key" placeholder="e.g. physiotherapy" value={row.key} onChange={(e) => handleBulkRowChange(index, "key", e.target.value)} />
              <Tooltip title="Remove row">
                <span>
                  <IconButton color="error" disabled={bulkRows.length === 1} onClick={() => handleRemoveBulkRow(index)} sx={{ mt: 1 }}>
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          ))}
          <Button startIcon={<AddIcon />} onClick={handleAddBulkRow} sx={{ textTransform: "none", color: BRAND.primary, fontWeight: 600 }}>
            Add Another Service
          </Button>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={resetBulkDialog} sx={{ textTransform: "none", color: "#64748B" }}>Cancel</Button>
          <Button variant="contained" onClick={handleAddServicesBulk} disabled={bulkSaving}
            sx={{ background: BRAND.gradient, textTransform: "none", fontWeight: 600 }}>
            {bulkSaving ? "Adding…" : validBulkCount > 0 ? `Add ${validBulkCount} Service${validBulkCount === 1 ? "" : "s"}` : "Add Services"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Confirm: delete community ── */}
      <ConfirmDialog
        open={deleteCommunityDialogOpen}
        title="Delete this community?"
        description={`This removes "${selectedCommunityObj?.name || ""}" and its service configuration. This can't be undone.`}
        confirmLabel="Delete Community"
        onCancel={() => setDeleteCommunityDialogOpen(false)}
        onConfirm={handleConfirmDeleteCommunity}
        loading={deletingCommunity}
      />

      {/* ── Confirm: delete service ── */}
      <ConfirmDialog
        open={Boolean(deleteServiceTarget)}
        title="Delete this service?"
        description={`This removes "${deleteServiceTarget?.name || ""}" from every community it's enabled for. This can't be undone.`}
        confirmLabel="Delete Service"
        onCancel={() => setDeleteServiceTarget(null)}
        onConfirm={handleConfirmDeleteService}
        loading={deletingService}
      />

      {/* ── Snackbar ── */}
      <Snackbar open={snackbar.open} autoHideDuration={3500} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: "100%", borderRadius: 2 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

    </Box>
  );
}